import React, { useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import { Button } from "@mui/material";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useLogin } from "../../contexts/LoginContext";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import Plans from "../components/Plans";


const Planos = () => {
    const navigate = useNavigate();
    const { fetchLogin } = useLogin();
    const [isMobile, setIsMobile] = useState(false);
    const [periodicity, setPeriodicity] = useState("mensal");

    const token = localStorage.getItem("token");
    const [hasPlan, setHasPlan] = useState(false);

    const planosRef = useRef(null);

    const scrollToPlans = () => {
        if (planosRef.current) {
            planosRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };



    useEffect(() => {
        const checkHasPlan = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/hasPlan`, {
                headers: {
                    Authorization: `${token}`
                }
            });
            if (response.data.status === 200) {
                setHasPlan(true)
            } else {
                setHasPlan(false)
            }
        }
        checkHasPlan()
    }, [token])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    const [objPlanos, setObjPlanos] = useState([]);

    useEffect(() => {
        const getPlanos = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarPlanos`);

            setObjPlanos(response.data.planos);
        }
        getPlanos();
    }, [])

    const plans = [
        {
            id: objPlanos[0]?.idPlano,
            title: objPlanos[0]?.nome,
            height: 700,
            chips: [
                { label: "Faixa de faturamento de até R$ 20.000/mês;" },
                { label: "Até 3 NFs/mês;" },
                { label: "Certificado digital;" },
                { label: "Obrigações fiscais;" },
                { label: "Atuação junto a planos de saúde;" },
                { label: "Onboarding até 10 dias úteis." },
            ],
            description: objPlanos[0]?.descricao,
            priceOld: objPlanos[0]?.valorAntigoMensal ? Number(objPlanos[0]?.valorAntigoMensal) : "",
            discount: objPlanos[0]?.descontoMensal ? Number(objPlanos[0]?.descontoMensal) : "",
            priceNew: Number(objPlanos[0]?.valorNovoMensal),
            priceOldYear: objPlanos[0]?.valorAntigoAnual ? Number(objPlanos[0]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[0]?.valorNovoAnual ? Number(objPlanos[0]?.valorNovoAnual) : "",
            discountYear: objPlanos[0]?.descontoAnual ? Number(objPlanos[0]?.descontoAnual) : "",
            img: "/assets/essencial.jpg",
        },
        {
            id: objPlanos[1]?.idPlano,
            title: objPlanos[1]?.nome,
            height: 700,
            chips: [
                { label: "Faixa de faturamento de até R$ 40.000/mês;" },
                { label: "Até 10 NFs/mês;" },
                { label: "Folha de até 2 colaboradores;" },
                { label: "Certificado digital;" },
                { label: "Obrigações fiscais;" },
                { label: "Atuação junto a planos de saúde;" },
                { label: "IRPF sócios (sob demanda, até 3);" },
                { label: "Atendimento online bimestral;" },
                { label: "Onboarding até 10 dias úteis." },
            ],
            description: objPlanos[1]?.descricao,
            priceOld: objPlanos[1]?.valorAntigoMensal ? Number(objPlanos[1]?.valorAntigoMensal) : "",
            discount: objPlanos[1]?.descontoMensal ? Number(objPlanos[1]?.descontoMensal) : "",
            priceNew: Number(objPlanos[1]?.valorNovoMensal),
            priceOldYear: objPlanos[1]?.valorAntigoAnual ? Number(objPlanos[1]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[1]?.valorNovoAnual ? Number(objPlanos[1]?.valorNovoAnual) : "",
            discountYear: objPlanos[1]?.descontoAnual ? Number(objPlanos[1]?.descontoAnual) : "",
            img: "/assets/profissional.jpg",
        },
        {
            id: objPlanos[2]?.idPlano,
            title: objPlanos[2]?.nome,
            height: 700,
            chips: [
                { label: "Faixa de faturamento de até R$ 150.000/mês;" },
                { label: "Até 150 NFs/mês;" },
                { label: "Folha de até 5 colaboradores;" },
                { label: "Certificado digital;" },
                { label: "Obrigações fiscais;" },
                { label: "Atuação junto a planos de saúde;" },
                { label: " IRPF sócios (sob demanda, até 3);" },
                { label: "Atendimento online mensal;" },
                { label: "Onboarding até 10 dias úteis." },
            ],
            description: objPlanos[2]?.descricao,
            priceOld: objPlanos[2]?.valorAntigoMensal ? Number(objPlanos[2]?.valorAntigoMensal) : "",
            discount: objPlanos[2]?.descontoMensal ? Number(objPlanos[2]?.descontoMensal) : "",
            priceNew: Number(objPlanos[2]?.valorNovoMensal),
            priceOldYear: objPlanos[2]?.valorAntigoAnual ? Number(objPlanos[2]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[2]?.valorNovoAnual ? Number(objPlanos[2]?.valorNovoAnual) : "",
            discountYear: objPlanos[2]?.descontoAnual ? Number(objPlanos[2]?.descontoAnual) : "",
            img: "/assets/expert.jpg",
        },
        {
            id: objPlanos[3]?.idPlano,
            title: objPlanos[3]?.nome,
            height: 700,
            chips: [
                { label: "Simples Nacional e outros regimes;" },
                { label: "Emissão de NF sob medida;" },
                { label: "Folha de pagamento personalizada;" },
                { label: "Certificado digital;" },
                { label: "Obrigações fiscais;" },
                { label: "Atuação junto a planos de saúde;" },
                { label: "IRPF até 2 sócios inclusos;" },
                { label: "Atendimento online ilimitado sob demanda;" },
                { label: "Condições personalizadas de pagamento;" },
                { label: "Onboarding até 10 dias úteis." },
            ],
            description: objPlanos[3]?.descricao,
            priceOld: objPlanos[3]?.valorAntigoMensal ? Number(objPlanos[3]?.valorAntigoMensal) : "",
            discount: objPlanos[3]?.descontoMensal ? Number(objPlanos[3]?.descontoMensal) : "",
            priceNew: Number(objPlanos[3]?.valorNovoMensal),
            priceOldYear: objPlanos[3]?.valorAntigoAnual ? Number(objPlanos[3]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[3]?.valorNovoAnual ? Number(objPlanos[3]?.valorNovoAnual) : "",
            discountYear: objPlanos[3]?.descontoAnual ? Number(objPlanos[3]?.descontoAnual) : "",
            img: "/assets/plus.jpg",
        }
    ];


    return (
        <>
            <Header active="planos" />
            <div style={{ marginTop: "100px", width: "100%", padding: "20px" }} >
                <div style={{
                    width: "80%",
                    maxWidth: "1200px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "20px",
                    margin: "0 auto"
                }}>
                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <img src="/assets/planosPage.jpg" alt="Descrição" style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "20px", // cantos arredondados suaves
                            objectFit: "cover",   // mantém proporção e evita distorção
                            boxShadow: "0 0px 14px #ffc845", // sombra leve para destacar
                        }} />
                    </motion.div>

                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>Planos pensados para quem cuida de vidas</h1>
                        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                            Nossos planos contábeis foram desenvolvidos especialmente para médicos, dentistas, psicólogos, fisioterapeutas e demais profissionais da saúde. Oferecemos soluções práticas e seguras que garantem o cumprimento das obrigações fiscais com total transparência, agilidade e tranquilidade. Cuidamos da parte contábil para que você possa focar no que realmente importa: cuidar de pessoas.
                        </p>
                    </motion.div>
                </div>
            </div>

            {/* <WhatWeDo scrollToPlans={scrollToPlans} /> */}
            {/* <Plans /> */}

            {plans.map((plan, index) => (
                <div key={index} style={{ width: "100%", padding: "20px", display: "flex", justifyContent: "center" }}>
                    <div style={{
                        marginBottom: "40px",
                        width: "100%",
                        maxWidth: "1200px",
                        display: "flex",
                        flexDirection: isMobile ? "column" : index % 2 === 0 ? "row" : "row-reverse",
                        alignItems: "center",
                        gap: "20px",
                        padding: "0 20px"
                    }}>
                        <div style={{ width: isMobile ? "100%" : "50%", padding: "0 10px" }}>
                            <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>{plan.title}</h1>
                            <p style={{ marginBottom: "10px", fontSize: "1.1rem" }}>{plan.description}</p>
                            <ul>
                                {plan.chips.map((advantage, i) => (
                                    <li key={i}>{advantage.label}</li>
                                ))}
                            </ul>
                            <p style={{ fontWeight: "bold", marginTop: "10px" }}>{plan.finalText}</p>
                            {plan.id === 4 ? (
                                <Button onClick={() => window.open(gerarLinkWhatsApp("Olá, tenho interesse no plano *Plus Personalizado* (Sob Consulta). Poderia me enviar mais informações?"))} variant="contained" sx={{
                                    padding: "14px 28px",
                                    fontSize: "1rem",
                                    backgroundColor: "#ffc845",
                                    color: "#0b243d",
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    transition: "0.3s ease",
                                    '&:hover': {
                                        backgroundColor: "#e6b53e",
                                        transform: "scale(1.05)",
                                    },
                                }}>
                                    quero contratar
                                </Button>
                            ) : (
                                <Button variant="contained" onClick={scrollToPlans} sx={{
                                    padding: "14px 28px",
                                    fontSize: "1rem",
                                    backgroundColor: "#ffc845",
                                    color: "#0b243d",
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    transition: "0.3s ease",
                                    '&:hover': {
                                        backgroundColor: "#e6b53e",
                                        transform: "scale(1.05)",
                                    },
                                }}>
                                    quero contratar
                                </Button>
                            )}
                        </div>
                        <div style={{ width: isMobile ? "100%" : "50%" }}>
                            <img
                                src={plan.img}
                                alt={plan.title}
                                style={{
                                    width: "80%",
                                    margin: "0 auto",
                                    height: "auto",
                                    borderRadius: "20px", // cantos arredondados suaves
                                    objectFit: "cover",   // mantém proporção e evita distorção
                                    boxShadow: "0 0px 14px #ffc845", // sombra leve para destacar
                                }}
                            />
                        </div>
                    </div>
                </div>
            ))}

            <div ref={planosRef}>
                <Plans title="Compare os Planos" />
            </div>


            <Footer />
        </>
    );
};

export default Planos;
